@if (control) {
  <mat-form-field>
    @if (label()) {
      <label
        [for]="inputId"
        [ngClass]="{ 'text-red': control.invalid && (control.dirty || control.touched) }"
      >
        <span
          >{{ label() }}
          @if (isRequired && !hideRequiredMarker()) {
            <span class="required">*</span>
          }
        </span>
      </label>
    }
    <textarea
      matInput
      [id]="inputId"
      [autocomplete]="inputId"
      [formControl]="control"
      [rows]="rows()"
      [readonly]="readonly()"
      [placeholder]="placeholder()"
      [attr.maxlength]="maxlength()"
    ></textarea>
    @if (showError) {
      <mat-error>{{ getErrorMessage(errorKeys[0]) }}</mat-error>
    }
  </mat-form-field>
}
